import { useAppState } from "core/contexts/AppContext";
import { getCountryCodeAndCurrencyCode } from "core/includes/countries";

/**
 * It provides the Currency and the Currency Symbol from CMS for Global.
 * This function returns
 *  1. Global: the Global Currency and the Global Currency Symbol
 *  2. Others: GBP(£), NZD($), or AUD($)
 *
 * @param userCountry
 */
export const useCountryAndCurrency = (userCountry?: string) => {
    const [appState] = useAppState();
    const isGlobal = appState.globalCurrencyOptions.isGlobal || appState.cart?.isGlobal;

    return getCountryCodeAndCurrencyCode(
        userCountry,
        isGlobal ? appState.globalCurrencyOptions.currency : null,
        isGlobal ? appState.globalCurrencyOptions.currencySymbol : null,
    );
};